import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'

const List = () => import('./views/List')
const Display = () => import('./views/Display')

const ROUTE_NAME = 'profile:holding:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const DISPLAY = p('display')
const CREATE = p('create')

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: accessPermission(['ADS:COMPANIES:VIEW_OWN'], options),
    }),
    route('create/', Display, CREATE, {
      meta: accessPermission(['ADS:COMPANIES:ADD'], options),
    }),
    route(':id/', Display, DISPLAY, {
      props: true,
      meta: accessPermission(['ADS:COMPANIES:VIEW_OWN'], options),
    }),
    { path: '*', redirect: { name: LIST } },
  ]
}
